import React, { useEffect } from 'react';
import { Line, Pie, Bar, Column } from '@ant-design/charts';
import './index.less';


const PageModel = props => {
	const data = [
		{
			action: '永丰路',
			pv: 5,
		},
		{
			action: '仓丰路',
			pv: 3,
		},
		{
			action: '三新北路',
			pv: 10,
		},
		{
			action: '仓桥路',
			pv: 6,
		},
	];
	const config = {
		forceFit: true,
		data,
		xField: 'pv',
		yField: 'action',
		conversionTag: { visible: true },
	};
	
	useEffect(() => {

	}, [123]);

	return (

		<Bar {...config} />
	);
};

export default PageModel;
